// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_DadosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /contratos/previa e /contratos/enviar — os dados que vão ao contrato da franquia (Full).
 * Os campos vazios ou inválidos não são erro de entrada: a prévia lista o que falta
 * (ContratoPadrao::pendencias) e o envio recusa com 422 dados_incompletos.
 */
import { registerContract } from './validate'

export interface Contratos_DadosInput {
franquia_id?: number
minuta_id?: number
franqueado_nome?: string
franqueado_cpf?: string
franqueado_endereco?: string
franqueado_email?: string
unidade_razao_social?: string
unidade_cnpj?: string
unidade_endereco?: string
franqueadora_nome?: string
franqueadora_email?: string
testemunha1_nome?: string
testemunha1_email?: string
testemunha2_nome?: string
testemunha2_email?: string
}

registerContract('Contratos_DadosInput', {
  franquia_id:          { type: 'number',  required: false },
  minuta_id:            { type: 'number',  required: false },
  franqueado_nome:      { type: 'string',  required: false },
  franqueado_cpf:       { type: 'string',  required: false },
  franqueado_endereco:  { type: 'string',  required: false },
  franqueado_email:     { type: 'string',  required: false },
  unidade_razao_social: { type: 'string',  required: false },
  unidade_cnpj:         { type: 'string',  required: false },
  unidade_endereco:     { type: 'string',  required: false },
  franqueadora_nome:    { type: 'string',  required: false },
  franqueadora_email:   { type: 'string',  required: false },
  testemunha1_nome:     { type: 'string',  required: false },
  testemunha1_email:    { type: 'string',  required: false },
  testemunha2_nome:     { type: 'string',  required: false },
  testemunha2_email:    { type: 'string',  required: false },
})
